import { isSupabaseConfigured } from "../supabase";
import { createLocalStorageReceiptStore } from "./localStorageStore";
import { createSupabaseReceiptStore } from "./supabaseStore";
import type { ReceiptStore } from "./types";

// Two implementations are kept side-by-side:
//   - supabaseStore: production / preview when Supabase env vars are set.
//   - localStorageStore: kept as the offline / E2E fallback. Do NOT delete
//     this file; Playwright runs with VITE_E2E_BYPASS_AUTH=true and falls
//     back to the local store so tests don't need a real Supabase project.
//
// Selection happens once at import time. Components import `receiptStore`
// from this module and never need to know which backend is in use.
const useLocal =
  import.meta.env.VITE_E2E_BYPASS_AUTH === "true" || !isSupabaseConfigured;

export const receiptStore: ReceiptStore = useLocal
  ? createLocalStorageReceiptStore()
  : createSupabaseReceiptStore();

export type { Receipt, ReceiptStore } from "./types";
